<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkingCode":"20180101101021224433",
          "billCode":"2018010110102122122",
          "thirdBillCode":"2018010110102122132",
          "refundValue":5.00,
          "refundDesc":"重复支付退款"
        },
        responseCode: {"data":{
            "refundCode":"2018010110102123112"
          },"message":"业务成功","resultCode":0,"status":1}	,
        infoData: {
          explain: "智慧停车开放平台主动请求，在订单发生退款时通知第三方接入系统对该订单进行退款，第三方务必在10s内响应，超时或返回失败我方将会重发",
          urlPattern: this.commonUrls.third + "refundParkFee",
          precondition: {
            preData: "通过接口",
            link:  " 缴费 ",
            url: "payParkFee",
            endData: "对车辆进行缴费"
          },
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "第三方接入系统提供接口入口, 智慧停车开放平台主动请求",
          frequency:"实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
              { info1: 'billCode', info2: '是', info3: 'String', info4: '支付流水号' },
              { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方支付流水号' },
              { info1: 'refundValue', info2: '是', info3: 'decimal', info4: '退款金额' },
              { info1: 'refundDesc', info2: '是', info3: 'String', info4: '退款说明' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'refundCode', info2: '是', info3: 'String', info4: '退款流水号' }
            ]
          }]
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/refundParkFee.vue